import $ from 'jquery'

function componentHistoryTabSwitcher() {
    $("ul.type a").on("click",function(){
        var active_class=$(this).attr("rel");
        $("ul.type a").each(function () {
            $(this).removeClass("active");
        });
        $("#cameraList ul.list_image").hide();
        $("#cameraList ul.list_movie").hide();
        $(this).addClass("active");
        $("#cameraList ul."+active_class).fadeIn();
        return false;
    });
}

export default componentHistoryTabSwitcher